import slider1 from "../images/banners/banner2.webp";

import abouticon from "../images/logo/Kunjveda_logo.png";
import slider2 from "../images/banners/spices_resize.webp";
import adbanner1 from "../images/otherImages/tea-leaves-powder.webp";
import adbanner2 from "../images/otherImages/biryani.webp";
import adbanner3 from "../images/otherImages/delivery-service.webp";

import { products } from "../data/productsData";
// -------------------      spices images ------------------------------
import turmericPowder from "../images/spices/turmeric2.jpg";
import redChilliPowder from "../images/spices/redChilliPowder.jpg";
import corianderPowder from "../images/spices/re-coriander.png";
import amchoor from "../images/spices/amchoor_resize.png";
import moringa from "../images/spices/moringaPowder.png";
import amla from "../images/spices/amla2.png";
import coriander from "../images/productList/coriander.png";
import turmeric from "../images/productList/turmeric.png";
import redChilli from "../images/productList/redChili.png";

import spiceDeal from "../images/adbanner/img2.webp";

import promobanner1 from "../images/adbanner/banner2.jpg";
import promobanner2 from "../images/banners/spices_resize.webp";

import clock from "../images/clock.svg";
import gift from "../images/gift.svg";
import package1 from "../images/package.svg";
import refresh from "../images/refresh-cw.svg";

import { Link } from "react-router-dom";
import React, { useState } from "react";
import ProductItem from "../ProductList/ProductItem";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import { Slide, Zoom } from "react-awesome-reveal";
import { useEffect } from "react";
// import { PulseLoader } from 'react-spinners';

import FAQ from "./FooterElements/Faq";
const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const settings1 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    autoplay: true,
    autoplaySpeed: 2000,
  };
  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    autoplay: true,
    autoplaySpeed: 2000,
  };
  // loading
  const [loaderStatus, setLoaderStatus] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);
  }, []);

  // product array
  const spiceCategories = [
    { id: 1, title: "Turmeric Powder", image: turmeric, alt: "Turmeric powder", link: "/ProductList", },
    { id: 2, title: "Coriander Powder", image: coriander, alt: "Coriander powder", link: "/ProductList", },
    { id: 3, title: "Red Chilli Powder", image: redChilli, alt: "Red chilli powder", link: "/ProductList", },
    { id: 4, title: "Amchoor Powder", image: amchoor, alt: "Amchoor Powder", link: "/ProductList", },
    { id: 5, title: "Moringa Powder", image: moringa, alt: "Moringa Powder", link: "/ProductList", },
    { id: 6, title: "Amla Powder", image: amla, alt: "Amla Powder", link: "/ProductList", },
  ];

  const renderStars = (rating) =>
    [1, 2, 3, 4, 5].map((n) => {
      let icon = "bi-star";                      // empty
      if (rating >= n) icon = "bi-star-fill";    // full
      else if (rating >= n - 0.5) icon = "bi-star-half"; // half
      return <i key={n} className={`bi ${icon}`} />;
    });


  const promoBanners = [
    {
      id: 1,
      title: "Spices",
      text: "",
      discount: "",
      image: promobanner1,
      link: "/ProductList",
      direction: "left",
    },
    {
      id: 2,
      title: "Masala Blends",
      text: "",
      discount: "",
      image: promobanner2,
      link: "/ProductList",
      direction: "right",
    },
  ];

  return (
    <div>
      <div>

        <>
          <>
            <div className="scroll-to-top">
              <button
                onClick={scrollToTop}
                className={`scroll-to-top-button ${isVisible ? "show" : ""}`}
              >
                ↑
              </button>
            </div>
            {/* hero-section */}
            <section className="hero-section">
              <div className="container mt-8">
                <div
                  id="carouselExampleFade"
                  className="carousel slide carousel-fade"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div
                        style={{
                          background: `url(${slider1}) no-repeat`,
                          backgroundSize: "cover",
                          borderRadius: ".5rem",
                          backgroundPosition: "center",
                        }}
                      >
                        <div className="ps-lg-12 py-lg-16 col-xxl-5 col-md-7 py-14 px-8 text-xs-center">
                          <span className="badge text-bg-warning">
                            {/* Opening Sale */}
                          </span>
                          <h2 className="text-dark display-5 fw-bold mt-4">
                            {/* Tradition in Every Grain. Flavour in Every Dish.  */}
                            Rooted in Nature. Rich in Flavour.
                          </h2>
                          <p className="lead">
                            Authentic spices. Exceptional aroma. Flavour in every meal.
                          </p>
                          <Link to={"/ProductList"} className="btn btn-dark mt-4 ">
                            Shop Spices
                            <i className="feather-icon icon-arrow-right ms-1" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item" >
                      <div
                        style={{
                          background: `url(${slider2}) no-repeat`,
                          backgroundSize: "cover",
                          borderRadius: ".5rem",
                          backgroundPosition: "center",
                          height: "540px"
                        }}
                      >
                        <div className="ps-lg-12 py-lg-16 col-xxl-5 col-md-7 py-14 px-8 text-xs-center">
                          <span className="badge text-bg-warning ">
                            {/* <h2>The True Taste of India.</h2> */}
                          </span>
                          <h2 className="text-dark display-5 fw-bold mt-4">
                            {" "}
                            {/* <span className="text-primary">$100</span> */}
                          </h2>
                          <p className="lead">

                          </p>
                          {/* <Link to="#!" className="btn btn-dark mt-3">
                              Shop Now{" "}
                              <i className="feather-icon icon-arrow-right ms-1" />
                            </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Link
                    className="carousel-control-prev"
                    to="#carouselExampleFade"
                    role="button"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Previous</span>
                  </Link>
                  <Link
                    className="carousel-control-next"
                    to="#carouselExampleFade"
                    role="button"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Next</span>
                  </Link>
                </div>
              </div>
            </section>
            {/* end hero-section */}
          </>

          <>
            <section className="mt-8">
              {/* contianer */}
              <div className="container ">
                <div className="row">
                  {/* col */}
                  <Slide direction="down">
                    <div className="col-12">
                      {/* cta */}
                      <div className="bg-light d-lg-flex justify-content-between align-items-center py-6 py-lg-3 px-8 rounded-3 text-center text-lg-start">
                        {/* img */}
                        <div className="d-lg-flex align-items-center">
                          <img
                            src={abouticon}
                            alt="about-icon"
                            className="img-fluid"
                            style={{
                              height: "100px"
                            }}
                          />
                          {/* text */}
                          <div className="ms-lg-4">
                            <h1 className="fs-2 mb-1">
                              Welcome to KunjVeda
                            </h1>
                            <span>
                              Spices in Bulk. Value in
                              <span className="text-primary"> Every Order.</span>
                            </span>
                          </div>
                        </div>
                        <div className="mt-3 mt-lg-0">
                          {/* btn */}
                          <Link to="/ProductList" className="btn btn-dark">
                            Explore Wholesale
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Slide>
                </div>
              </div>
            </section>
          </>

          <>
            {/* Why choose us section  */}
            <section className="why-choose-section">
              <div className="container">
                <div className="text-center mb-5">
                  <h2 className="why-choose-heading">
                    Your <em>Best Choice</em> for Kitchen
                  </h2>
                </div>

                <div className="row justify-content-center text-center">
                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="feature-card">
                      <div className="feature-icon">
                        <img
                          src={adbanner1}
                          alt="ad-banner"
                          className="mb-3"
                          style={{
                            width: "100px",
                            height: "100px",
                            loading: "lazy"
                          }}
                        />
                      </div>
                      <h3 className="feature-title">Trusted Quality</h3>
                      <p className="feature-description">
                        Made with ingredients you can trust every day.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="feature-card">
                      <div className="feature-icon">
                        <img
                          src={adbanner2}
                          alt="ad-banner-2"
                          className="mb-3"
                          style={{
                            width: "100px",
                            height: "100px",
                            loading: "lazy"
                          }}
                        />
                      </div>
                      <h3 className="feature-title">Authentic Taste</h3>
                      <p className="feature-description">
                        Real Indian flavours for homemade meals.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="feature-card">
                      <div className="feature-icon">
                        <img
                          src={adbanner3}
                          alt="aad-banner-3"
                          className="mb-3"
                          style={{
                            width: "100px",
                            height: "100px",
                            loading: "lazy"
                          }}
                        />
                      </div>
                      <h3 className="feature-title">Safe Packaging</h3>
                      <p className="feature-description">
                        Packed with care for lasting freshness.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
          <>
            {/* Dynamic Spice Categories Section */}
            <section className="my-lg-14 my-8">
              <div className="container">
                {/* Section Heading */}
                <div className="section-head text-center mt-8 mb-6">
                  <h3
                    className="h3style"
                    data-title="Shop Our Spice Collection"
                  >
                    Shop Our Spice Collection
                  </h3>

                  <div className="wt-separator bg-primarys"></div>
                  <div className="wt-separator2 bg-primarys"></div>

                  <p className="mt-3">
                    Discover authentic Indian spices for every kitchen.
                  </p>
                </div>

                {/* Dynamic Categories */}
                <div className="row">
                  {spiceCategories.map((category) => (
                    <div
                      className="col-xl-2 col-lg-2 col-md-3 col-6 fade-zoom"
                      key={category.id}
                    >
                      <Zoom triggerOnce>
                        <div className="text-center mb-5 spice-category-card">
                          <Link to={category.link}>
                            <img
                              src={category.image}
                              alt={category.alt}
                              className="card-image rounded-circle"
                              loading="lazy"
                              style={{
                                width: "120px",
                                height: "80px",
                                objectFit: "cover", // or "contain" if transparent PNG  
                              }}

                            />
                          </Link>

                          <div className="mt-4">
                            <h5 className="fs-6 mb-0">
                              <Link
                                to={category.link}
                                className="text-inherit"
                              >
                                {category.title}
                              </Link>
                            </h5>
                          </div>
                        </div>
                      </Zoom>
                    </div>
                  ))}
                </div>
              </div>
            </section>
            {/* End Dynamic Spice Categories */}
          </>

          <>
            <section>
              <div className="container">
                <div className="row">
                  {promoBanners.map((banner) => (
                    <div
                      className="col-12 col-lg-6 mb-3 mb-lg-0 fade-in-left"
                      key={banner.id}
                    >
                      <Slide direction={banner.direction} triggerOnce>
                        <div>
                          <div
                            className="py-10 px-8 rounded-3"
                            style={{
                              background: `url(${banner.image}) no-repeat`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              minHeight: 220,
                            }}
                          >
                            <div>
                              <h3 className="fw-bold mb-1">{banner.title}</h3>
                              <p className="mb-4">
                                {banner.text}{" "}
                                <span className="fw-bold">{banner.discount}</span>
                              </p>
                              <Link to={banner.link} className="btn btn-dark">
                                Shop Now
                              </Link>
                            </div>
                          </div>
                        </div>
                      </Slide>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </>

          <>
            {/* <ProductItem /> */}
          </>

          <>
            {/* Daily Best Sells */}
            <section>
              <div className="container">
                <div className="row">
                  <div className="col-md-12 mb-6">
                    <div className="section-head text-center mt-8">
                      <h3 className="h3style" data-title="Daily Best Sells">
                        Daily Best Sells
                      </h3>
                      <div className="wt-separator bg-primarys"></div>
                      <div className="wt-separator2 bg-primarys"></div>
                      {/* <p>Connecting with entrepreneurs online, is just a few clicks away.</p> */}
                    </div>
                  </div>
                </div>
                <div className="row row-cols-1 row-cols-md-3 g-4">
                  <div className="col-md-3 fade-in-left">
                    <div
                      className="position-relative rounded-3 overflow-hidden h-100"
                      style={{ minHeight: 380 }}
                    >
                      <img
                        src={spiceDeal}
                        alt="Freshly ground spices"
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{ objectFit: "cover", objectPosition: "center" }}
                      />

                      {/* dark overlay so the text is readable */}
                      <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background:
                            "linear-gradient(to top, rgba(0,0,0,.75) 0%, rgba(0,0,0,.25) 60%, rgba(0,0,0,.1) 100%)",
                        }}
                      />

                      {/* text at the bottom */}
                      <div className="position-absolute bottom-0 start-0 p-4">
                        <h3 className="fw-bold text-white mb-1">Freshly Ground Spices.</h3>
                        <p className="text-white mb-3">Get the best deal on bulk orders.</p>
                        <Link to="/Contact" className="btn btn-primary">
                          Enquiry Now
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9 ">
                    <div className="image-itemss">
                      <Slider {...settings1}>
                        {products.map((item) => (
                          <div className="images swiper-slide px-4" key={item.id}>
                            <div className="col">
                              <div className="card card-product">
                                <div className="card-body">
                                  <div className="text-center position-relative">
                                    <Link to={`/ProductList/ProductDetail/${item.id}`}>
                                      <img
                                        src={item.image}
                                        alt={item.name}
                                        className="mb-3 img-fluid d-block mx-auto"
                                        loading="lazy"
                                        style={{ height: "250px", objectFit: "contain" }}
                                      />
                                    </Link>
                                    {/* <div className="card-product-action">
                                      <Link to={`/ProductList/ProductDetail/${item.id}`} className="btn-action" title="Quick View"><i className="bi bi-eye" /></Link>
                                      <Link to="#!" className="btn-action" title="Wishlist"><i className="bi bi-heart" /></Link>
                                    </div> */}
                                  </div>

                                  <div className="text-small mb-1">
                                    <Link to="/ProductList" className="text-decoration-none text-muted">
                                      <small>{item.category}</small>
                                    </Link>
                                  </div>

                                  <h2 className="fs-6">
                                    <Link to={`/ProductList/ProductDetail/${item.id}`} className="text-inherit text-decoration-none">
                                      {item.name}
                                    </Link>
                                  </h2>
                                  <small className="text-muted">{item.weight}</small>

                                  <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div>
                                      <span className="text-dark">₹{item.price}</span>{" "}
                                      <span className="text-decoration-line-through text-muted"></span>
                                    </div>
                                    <div>
                                      <small className="text-warning">{renderStars(item.rating)}</small>{" "}
                                      <small>{item.rating}</small>
                                    </div>
                                  </div>

                                  <div className="d-grid mt-2">
                                    <Link to={`/ProductList/ProductDetail/${item.id}`} className="btn btn-primary">View Details</Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>

          <>
            <section className="my-lg-14 my-8">
              <div className="container" style={{ marginTop: 50 }}>
                <div
                  className="row justify-content-center  g-4"
                  style={{ textAlign: "center" }}
                >
                  <div className="col-md-3 col-sm-6 fade-zoom ">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20">
                            <div className="mb-6">
                              <img src={refresh} alt="refresh" />
                            </div>
                          </div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3">Easy Returns</h3>
                            <p>
                              Received a damaged or wrong product? Contact us and we will replace it.
                              {/* <Link to="#!">policy</Link>. */}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20">
                            <div className="mb-6">
                              <img src={package1} alt="package" />
                            </div>
                          </div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3">Wide Spice Range</h3>
                            <p>
                              Choose from whole spices, ground powders, masalas and blends, all in one place.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20">
                            <div className="mb-6">
                              <img src={gift} alt="gift" />
                            </div>
                          </div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3">
                              Best Prices &amp; Bulk Offers
                            </h3>
                            <p>
                              Special wholesale rates and discounts on bulk orders for homes, restaurants and shops.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20">
                            <div className="mb-6">
                              <img src={clock} alt="clock" />
                            </div>
                          </div>
                          <div className="icon-content">
                            {/* <h4 className="wt-tilte">Reports</h4> */}
                            <h3 className="h5 mb-3">Fast Delivery</h3>
                            <p class="ms-2">
                              Freshly packed orders are dispatched quickly and delivered to your doorstep.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                </div>
              </div>
            </section>
          </>
          <>
            {/* <FAQ/> */}
          </>
          <>
            <section className="my-lg-14 my-8">
              <div className="container" >
                <Slider {...settings2}>
                  {products.map((item) => (
                    <div className="images swiper-slide p-4" key={item.id}>
                      <div className="item">
                        <Link to={`/ProductList/ProductDetail/${item.id}`} className="text-decoration-none text-inherit">
                          <div className="card card-product mb-4">
                            <div className="card-body text-center py-8">
                              <img
                                src={item.image}
                                alt={item.alt}
                                className="mb-3 img-fluid d-block mx-auto"
                                loading="lazy"
                                style={{ height: "160px", objectFit: "contain" }}
                              />
                              <div>{item.name}</div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </section>
          </>


        </>

      </div>
    </div>
  );
};

export default Home;
